


































import { Component, Prop, Vue } from 'vue-property-decorator';
import FormRow from '@/components/common/forms/FormRow.vue';
import FormInput from '@/components/common/forms/FormInput.vue';
import FormError from '@/components/common/forms/FormError.vue';
import FormTextarea from '@/components/common/forms/FormTextarea.vue';
import MdComponent from '@/components/common/MdComponent.vue';
import AdmiralCheckbox from '@/components/common/selects/AdmiralCheckbox.vue';
import { CheckIcon } from 'vue-feather-icons';
import Multiselect from 'vue-multiselect';
import FormRating from '@/components/common/forms/FormRating.vue';
import { FeedbackModel } from 'admiral-core';

@Component({
  components: {
    MdComponent,
    FormTextarea,
    FormError,
    FormInput,
    FormRow,
    AdmiralCheckbox,
    CheckIcon,
    Multiselect,
    FormRating,
  },
})
export default class FeedbackForm extends Vue {
  @Prop({ required: true, type: Object })
  readonly value!: FeedbackModel;

  @Prop({ required: true, type: Object })
  readonly errors!: FeedbackModel;

  @Prop({ required: false, type: Boolean, default: false })
  readonly disabled!: boolean;

  async mounted() {
    //
  }

  onInput(key: string, value: any) {
    this.$emit('input', { ...this.value, [key]: value });
  }
}
